import { render, staticRenderFns } from "./featured-in.vue?vue&type=template&id=203d7546&"
import script from "./featured-in.vue?vue&type=script&lang=js&"
export * from "./featured-in.vue?vue&type=script&lang=js&"
import style0 from "./featured-in.vue?vue&type=style&index=0&id=203d7546&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports